module.exports = __webpack_public_path__ + "img/p4@2x.7519a024.png";